import { Stack } from "@mui/material";
import { ChipsItems } from "helper";
import Cards from "components/MyActivityComponents/Cards";
import Chip from "components/MyActivityComponents/Chip";
import { useGetAllOrderRelatedSubsQuery } from "api/order";

const ActivityHistory = () => {
  const { data: order, isLoading } = useGetAllOrderRelatedSubsQuery("approved");
  return isLoading ? (
    <p>Loading...</p>
  ) : (
    <>
      <Stack spacing={1} direction="row">
        {ChipsItems.map((item) => (
          <Chip
            label={item.label}
            variant="outlined"
            onClick={(id) => {
              console.log(`Chip no ${id} clicked`);
            }}
            id={item.id}
          />
        ))}
      </Stack>
      {
        order && order.length > 0 ? (
          <>
            {order &&
              order?.map((item) => {
                let orderTemp = {
                  img: "https://picsum.photos/200",
                  label: "Personal subscription",
                  heading: "Baked Fish Fillets with Cheese Sauce",
                  address: "Chef Juna Food, 4474 Bridge",
                  date: "12 Oct -12 Nov 2021",
                  chipColor: "#7B49E5",
                };
                if (item) {
                  orderTemp.date = `${new Date(
                    item.deliveryDetails[0].subscriptionId.from
                  ).toDateString()} - ${new Date(
                    item.deliveryDetails[0].subscriptionId.to
                  ).toDateString()} `;
                  orderTemp.address = item.deliveryDetails[0].deliveryTo.address;
                  orderTemp.label = item.deliveryDetails[0].subscriptionId.type;
                }
                return (
                  <Cards
                    data={orderTemp}
                    handleChange={(e) => {
                      console.log("eee", e);
                    }}
                    hasActionButton={false}
                  />
                );
              })}
          </>
        ) : (
          <>

          </>
        )
      }

    </>
  );
};


export default ActivityHistory